import React from 'react';
import EvolvedImage from '../components/EvolvedImage';

const IMAGE_ASSET = 'embedded-asset-block';
const lang = 'nb-NO';

export const renderAsset: React.FC<any> = (node) => {
  if (node.nodeType === IMAGE_ASSET) {
    const description = node.data.target.fields.description[lang];
    const { fileName } = node.data.target.fields.file[lang];
    return <EvolvedImage alt={description} fileName={fileName} />;
  }

  return null;
};
